import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { translate } from './translateFunction';
import './UserRequest.css'; // Importiert die angepasste CSS-Datei

const UserFeatures = () => {
  const [translations, setTranslations] = useState({
    additionalFeaturesTitle: '',
    exportButtonLabel: '',
    playVideoLabel: '',
    showPdfLabel: '',
  });

  const videoRef = useRef(null);
  const [showVideo, setShowVideo] = useState(false);
  const [showPdf, setShowPdf] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const loadTranslations = async () => {
      const additionalFeaturesTitle = await translate(440); // "Weitere Funktionen"
      const exportButtonLabel = await translate(443); // "Export starten"
      const playVideoLabel = await translate(444); // "Video abspielen"
      const showPdfLabel = await translate(442); // "PDF anzeigen"

      setTranslations({
        additionalFeaturesTitle,
        exportButtonLabel,
        playVideoLabel,
        showPdfLabel,
      });
    };

    loadTranslations();
  }, []);

  const handleExportClick = () => {
    navigate('/feedback-selection-export');
  };

  const handleNextClick = () => {
    setShowVideo(true);
  };

  const handleShowPdfClick = () => {
    setShowPdf(true);
  };

  const handleCloseVideo = () => {
    setShowVideo(false);
  };

  const handleClosePdf = () => {
    setShowPdf(false);
  };

  return (
    <div className="user-features">
      <h3>{translations.additionalFeaturesTitle}</h3>
      <div className="button-container">
        <button className="custom-button" onClick={handleExportClick}>
          <img src="/dist/img/i1.png" alt="Export Icon" className="button-icon" />
          {translations.exportButtonLabel}
        </button>
        <button className="custom-button" onClick={handleNextClick}>
          <img src="/dist/img/i2.png" alt="Video Icon" className="button-icon" />
          {translations.playVideoLabel}
        </button>
        <button className="custom-button" onClick={handleShowPdfClick}>
          <img src="/dist/img/i3.png" alt="PDF Icon" className="button-icon" />
          {translations.showPdfLabel}
        </button>
      </div>

      {showVideo && (
        <div className="overlay">
          <div className="video-container">
            <video
              ref={videoRef}
              controls
              className="video-player"
              style={{ backgroundColor: 'black' }}
            >
              <source
                src="/dist/video/ClientEcho_Introducing_20250121.mp4"
                type="video/mp4"
              />
              Dein Browser unterstützt dieses Video nicht.
            </video>
            <button className="close-button" onClick={handleCloseVideo}>
              X
            </button>
          </div>
        </div>
      )}

      {showPdf && (
        <div className="overlay">
          <div className="pdf-container">
            <iframe
              src="/dist/pdf/Swisscom_ClientEcho_Guide.pdf"
              className="pdf-viewer"
              title="PDF Viewer"
            />
            <button className="close-button" onClick={handleClosePdf}>
              X
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserFeatures;
